(function () {
  function init() {
    document.querySelectorAll('.content-product-showcase__buy-form').forEach(function (form) {
      var button = form.querySelector('.content-product-showcase__buy-button');
      if (!button) return;

      if (form.dataset.hasVariants === 'true') {
        // Switch this button to type="button" so clicking it never fires a
        // submit event at all — cart-drawer apps (e.g. UpCart) install a
        // global, capture-phase listener for any /cart/add form submit and
        // handle it themselves before our own submit handler on the form
        // would ever run, so preventDefault() inside a submit listener
        // can't reliably stop that. A plain click listener on the button
        // has nothing for that global interception to catch.
        button.type = 'button';
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (!window.KinujoQuickAdd) return;

          var group = form.dataset.variantGroup;
          if (group) {
            window.KinujoQuickAdd.openGroup(group.split(','), form.dataset.variantGroupLabel);
          } else {
            window.KinujoQuickAdd.open(form.dataset.productHandle);
          }
        });
        return;
      }

      var originalLabel = button.textContent;

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (button.disabled) return;

        button.disabled = true;
        var formData = new FormData(form);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        })
          .then(function (response) {
            if (!response.ok) throw new Error('cart add failed');
            // A cart-drawer app listening for /cart/add.js requests (most
            // are) picks this up and opens on its own — this button just
            // needs to give feedback in case it doesn't.
            button.textContent = '追加しました';
            setTimeout(function () {
              button.textContent = originalLabel;
              button.disabled = false;
            }, 1500);
          })
          .catch(function () {
            button.disabled = false;
          });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
